module.exports = __webpack_public_path__ + "img/r2sf.f504c78d.png";